<main class="flex h-dvh w-dvw">
  <div class="flex h-full w-1/2 items-center justify-center overflow-hidden">
    <img src="bg/welcome.webp" class="h-full max-w-fit" />
  </div>

  <div
    class="flex h-full w-1/2 flex-col items-center justify-center bg-surface-100">
    <div class="mr-8 flex h-20 items-center self-end">
      <img src="logos/cxc_fullcolor.svg" class="h-14" />
    </div>

    <div class="fade-out-to-in flex grow flex-wrap place-content-center">
      <loader-wrapper
        [showBackgroundComponent]="true"
        class="relative [&>div:last-child]:absolute">
        <router-outlet></router-outlet>
      </loader-wrapper>
    </div>

    <div class="flex h-20 items-center self-end">
      <small class="mr-8 text-xs text-surface-500">
        Copyright © {{ currentYear }} Tecnología en Cuentas Por Cobrar. All
        rights reserved.
      </small>
    </div>
  </div>
</main>
